"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Authenticated User API
 * # Introduction The purpose of this API is to fetch user information using the IST JWT token header. # Changelog   ## 1.2   - Migrated to OpenApi specification    ## 1.1   - Added \'translations\' and \'settings\' to the User
 *
 * The version of the OpenAPI document: 1.2
 * Contact: info@ist.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./api"), exports);
__exportStar(require("./configuration"), exports);
__exportStar(require("./api/model"), exports);
